export default function BrokerCoverageChart() {
  const brokers = [
    { name: 'Echo', color: 'bg-blue-600' },
    { name: 'CH Robinson', color: 'bg-blue-500' },
    { name: 'Uber Freight', color: 'bg-blue-400' },
    { name: 'RXO', color: 'bg-blue-300' },
  ];

  return (
    <div
      className="bg-white rounded-[18px] border border-zinc-200 p-6 md:p-8"
      style={{
        boxShadow: '0 20px 45px -24px rgba(15,23,42,0.35)',
      }}
    >
      <h3 className="text-sm font-semibold text-zinc-900 mb-1">
        Broker Integration
      </h3>
      <p className="text-xs text-zinc-500 mb-6">
        All four major brokers connected to unified search
      </p>
      <div className="space-y-3">
        {brokers.map((broker) => (
          <div key={broker.name} className="flex items-center gap-3">
            <span className="text-xs font-medium text-zinc-700 w-24 md:w-28 flex-shrink-0">
              {broker.name}
            </span>
            <div className="flex-1 h-7 bg-zinc-100 rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full animate-bar-grow ${broker.color}`}
              />
            </div>
            <span className="text-xs text-zinc-500 flex-shrink-0">Active</span>
          </div>
        ))}
      </div>
    </div>
  );
}